<template>
  <div>
    <div class="text-center q-py-lg">
      <import-posts-btn
        :account="account"
        color="primary"
        rounded
      />
    </div>
    <q-separator />
    <div v-if="account.reconnectRequest">
      <import-request
        v-if="account.reconnectRequest.assignee === 'client'"
        :request="account.reconnectRequest"
        :platform="account.socialSite.name"
      />
      <import-initiated
        v-else-if="account.reconnectRequest.assignee === 'support'"
        :account="account"
      />
    </div>
    <request-new-posts v-else :account="account" />
    <q-separator />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Account } from '@/social/types';
import ImportPostsBtn from '../../post/import/with-account/ImportPostsBtn.vue';
import RequestNewPosts from '../RequestNewPosts.vue';
import ImportRequest from '../ImportRequest.vue';
import ImportInitiated from '../ImportInitiated.vue';

export default defineComponent({
  components: {
    ImportPostsBtn,
    ImportInitiated,
    ImportRequest,
    RequestNewPosts,
  },
  props: {
    account: {
      type: Object as () => Account,
      required: true,
    },
  },
});
</script>
